<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <!-- <div class="row">
      <div class="col-12">
        <navbar
          isBlur="blur  border-radius-lg my-3 py-2 start-0 end-0 mx-4 shadow"
          v-bind:darkMode="true"
          isBtn="bg-gradient-success"
        />
      </div>
    </div> -->
  </div>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div
              class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0"
            >
              <div class="card card-plain">
                
                <div class="card-body-6">
                  <form role="form" @submit.stop.prevent="sendData">
                    <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Ingreso</h4>
                  <p class="mb-0">Ingresa tu usuario y password</p>
                </div>
                    <div class="row-col-5">
                      <div class="col-md-5">
                        <label
                          for="example-text-input"
                          class="form-control-label"
                          >Username</label
                        >
                        <argon-input type="text" v-model="model.usuario" />
                      </div>
                      <div class="col-md-5">
                        <label
                          for="example-text-input"
                          class="form-control-label"
                          >Password</label
                        >
                        <argon-input type="password" v-model="model.password" />
                      </div>
                    </div>
                    <argon-button  
                      size="sm"
                      class="ms-auto bg-gray"
                      >Guardar</argon-button
                    >
                    <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <p class="mx-auto mb-4 text-sm">
                    Crear nueva cuenta
                    <a
                      @click="goto"
                      class="text-success text-gradient font-weight-bold"
                      >Registrar</a
                    >
                  </p>
                </div>
                  </form>
                </div>
                
              </div>
            </div>
            <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column"
            >
              <div
                class="position-relative bg-gradient-info h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                :style="{ 'background-image': 'url(' + imageUrl + ')',  'background-size': 'cover'}"
              >
              <!-- background-size: cover;-->
                <span class="mask bg-gradient-success opacity-6"></span>
                <h4
                  class="mt-5 text-gray font-weight-bolder position-relative"
                >
                  "Plataforma para Tramite de Retiro por Desempleo"
                </h4>
                <p class="text-gray position-relative">
                  Administración y proceso de los trámites
                </p>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
<script setup>
import { onBeforeUnmount, onBeforeMount } from "vue";
import { useStore } from "vuex";
// import Navbar from "@/examples/PageLayout/Navbar.vue";
// import ArgonSwitch from "@/components/ArgonSwitch.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
const body = document.getElementsByTagName("body")[0];

const store = useStore();
onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  body.classList.remove("bg-gray-100");
  localStorage.clear();
});
onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  body.classList.add("bg-gray-100");
});
</script>
<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import usuario from "../api/usuario";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      imageUrl: require("../assets/img/imageLogin.jpeg"), // Utiliza require para importar imágenes en Vue.js
      model:{
        usuario:"",
        password:""
      }
    };
  },
  methods: {
    sendData() {
      usuario
        .logIn(this.model)
        .then((result) => {
          console.log(result.data[0])
          if (result.data[0].id != null) {
            Swal.fire({
              title: "Login Correcto",
              text: "Login correcto",
              icon: "success",
              confirmButtonColor: "success",
              confirmButtonText: "Continuar",
            });
            localStorage.setItem("id",result.data[0].id)
            localStorage.setItem("email",result.data[0].email)
            localStorage.setItem("gerente",result.data[0].gerente)
            localStorage.setItem("usuario",result.data[0].usuario)
            localStorage.setItem("tipo",result.data[0].nivel)
            localStorage.setItem("nivel",result.data[0].nivel)
            localStorage.setItem("estado",result.data[0].estado)
            localStorage.setItem("delegacion",result.data[0].delegacion)
            localStorage.setItem("direccion",result.data[0].direccion)
            localStorage.setItem("cp",result.data[0].cp)
            localStorage.setItem("telefono",result.data[0].telefono)
            localStorage.setItem("nombre",result.data[0].nombre)
            localStorage.setItem("paterno",result.data[0].paterno)
            localStorage.setItem("materno",result.data[0].materno)
            localStorage.setItem("fechaCreacion",result.data[0].fechaCreacion)
            this.$router.push({ path: "/Dashboard" });
          } else {
            Swal.fire({
              title: "Error de Ingreso",
              text: result.data[0],
              icon: "error",
              confirmButtonColor: "error",
              confirmButtonText: "Continuar",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });

      this.model.usuario = "";
      this.model.password = "";
    },
    goto() {
      this.$router.push({ path: "/registro" });
    },
  },
};
</script>
